import { type NatsConnection, tokenAuthenticator, wsconnect } from "@nats-io/nats-core";

export async function createNatsConnection(
  natsUrl: string,
  ldDomain: "individuals" | "business",
  clerkToken: string,
): Promise<NatsConnection> {
  return wsconnect({
    servers: natsUrl.split(","),
    authenticator: tokenAuthenticator(`${ldDomain} ${clerkToken}`),
  });
}
